module.exports = __webpack_public_path__ + "img/error-b&w.f1a2da07.svg";